// extracted by mini-css-extract-plugin
export default {"aboutNav":"about-us-nav_aboutNav__HBGEy","main":"about-us-nav_main__-ODmZ","info":"about-us-nav_info__noakC","btns":"about-us-nav_btns__7iZgi","title":"about-us-nav_title__KkT1d"};